$(document).ready(function ()
{
  if ($('.o-js-investment_submit').length) {
    let input = $('.o-js-investment_form .o-js-client1 input[required="required"]').last()
    if (!input.length) {
      input = $('.o-js-investment_form input[required="required"]').last()
    }

    input.on('keyup', function(e) {
      if ($(this).val() == '') {
        $('.o-js-investment_submit').addClass('disabled').attr('disabled', true)
      } else {
        $('.o-js-investment_submit').removeClass('disabled').attr('disabled', false)
      }
    })
  }

  // Co-souscripteur : affichage / retrait du second bloc client
  $('.o-js-client2-toggle').on('click', function() {
    const button = $(this)
    const block = $('.o-js-client2')
    const isVisible = !block.prop('hidden')

    block.prop('hidden', isVisible)
    $('#o-js-remove-client2').val(isVisible ? '1' : '0')
    button.text(isVisible ? button.data('add-label') : button.data('remove-label'))
  })

  // Documents dropdown
  $('.o-docs-dropdown__caret').on('click', function(e) {
    e.stopPropagation()
    $(this).siblings('.o-docs-dropdown__menu').toggleClass('is-open')
  })

  $(document).on('click', function() {
    $('.o-docs-dropdown__menu').removeClass('is-open')
  })

  $('.o-docs-dropdown__menu').on('click', function(e) {
    e.stopPropagation()
  })
})
